import { useState } from "react";
import LoggingAPI from "../../api/logging/index.js";
import QaChecklistAPI from "../../api/quality_assurance/checklists.js";
import { Button, Modal } from "@monolith-forensics/monolith-ui";
import ButtonMenu from "../Forms/components/ButtonMenu.js";
import { usePermissions } from "../../hooks/usePermissions";

export const DeleteQaChecklistModal = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  buttonProps = {},
  defaultInfo,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const { currentUser } = usePermissions();

  const handleSubmit = async () => {
    setSubmitting(true);

    await QaChecklistAPI.deleteQAChecklist({
      checklist_id: defaultInfo.checklist_id,
    });

    LoggingAPI.createLog({
      user_id: currentUser.user_id,
      message: `Deleted QA checklist: ${defaultInfo.checklist_name}.`,
      event: "delete_qa_checklist",
      object_type: "qa_checklist",
      object_uuid: defaultInfo.checklist_id,
    });

    onSubmit?.(defaultInfo);
    setSubmitting(false);
    onClose?.();
  };

  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <Modal.Title>Delete QA Checklist</Modal.Title>
      <div style={{ fontWeight: 600, margin: "20px 0px" }}>
        Are you sure you want to delete the QA Checklist{" "}
        <span style={{ fontWeight: 600 }}>"{defaultInfo?.checklist_name}"</span>
        ?
      </div>
      <ButtonMenu>
        <Button
          size="xs"
          variant="subtle"
          onClick={handleCancel}
          disabled={submitting}
        >
          {buttonProps?.cancelText || "Cancel"}
        </Button>
        <Button
          size="xs"
          color="error"
          variant="contained"
          onClick={handleSubmit}
          disabled={submitting}
          loading={submitting}
        >
          {buttonProps?.submitText || "Delete QA Checklist"}
        </Button>
      </ButtonMenu>
    </Modal>
  );
};
